import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TakephotoComponent } from 'projects/core/src/common/takephoto/takephoto.component';
import { Globals } from 'projects/core/src/globals';
import { Helper } from 'projects/core/src/helper';
import { UploadService } from 'projects/core/src/lib/upload.service';
import { AddressComponent } from '../../../views/address/address.component';
import { AddressDetailsComponent } from '../../../views/address/address-details/address-details.component';
import { UploadfileComponent } from '../../uploadfile/uploadfile.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InventoriesService } from '../../../services/inventories.service';
import { CashregisterService } from '../../../services/cashregister.service';
import { SystemService } from 'projects/core/src/lib/system.service';
import { FormsService } from 'projects/core/src/lib/forms.service';
import { DocumentsComponent } from '../../../views/documents/documents.component';
import { DocumentsDetailsComponent } from '../../../views/documents/documents-details/documents-details.component';
import { DocumentsModule } from '../../../views/documents/documents.module';
import { DocumentsTemplateService } from '../../../services/documents-template.service';
import { Document, Documents } from '../../../db/documents';
import { DocumentlistComponent } from '../../../views/documents/documentlist/documentlist.component';
import { ToastMode} from 'projects/core/src/include/structures';
import { DocumentsService } from '../../../services/documents.service';
import { TemplatesService } from 'projects/core/src/lib/templates.service';
import { TemplatePreviewComponent } from '../../template-preview/template-preview.component';

@Component({
  selector: 'app-field',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.css']
})
export class FieldComponent implements OnInit {

  @ViewChild("modalImportTable")
  modalImportTable?:TemplateRef<any>
  modalImportTableRef:any;
  tableDataImport;

  @ViewChild("modalTableDetail")
  modalTableDetail?:TemplateRef<any>
  modalTableDetailRef:any;
  searchTableText="";
  dataFromImport="";
  dataFromFormat="json";
  dataFromField:any;

  @Input()
  field:any=null;

  @Input()
  fields:any=[];

  @Input()
  record:any; //record necessario per la parserizzazione delle keyword 

  @Input()
  disabled:boolean=false;

  @Input()
  force_label=false;

  @Input()
  noLabel=false;

  @Input()
  phases:any=[];

  filter_boolean:any={}

  fields_detail=[];

  inventories:any=[];
  cashes:any=[];

  editFieldCurrency=false;

  @ViewChild('currencyInput')
  set currencyInput(input: ElementRef<HTMLInputElement> | undefined){
    input?.nativeElement.focus();
  }

  constructor(
    private uploadService:UploadService,
    private modalService:NgbModal,
    private inventoriesService:InventoriesService,
    private cashregisterService:CashregisterService,
    private systemService:SystemService,
    private formsService:FormsService
  
  
  ) { }


  is_select_localdb=false;

  ngOnInit(): void {
    
    this.getInventories();
    this.getCashes();
    this.setDefaultValue();
  }

  getInventories(){
    this.inventoriesService.getInventories().subscribe((result)=>{
      this.inventories=result;
    })
  }

  getCashes(){
    this.cashregisterService.getCashes().subscribe((result)=>{
      this.cashes=result;
    })
  }

  setDefaultValue(){
     if(this.field.value=="" || this.field.value==null || this.field.value==undefined){
      if (this.field.defaultvalue!=""){
        this.field.value=this.field.defaultvalue;
      }
    }

    if(this.field.type=="select"){

     


      //cerca la keyword sql (se presente nel default value)
      let pos_sql_keyword=this.field.defaultvalue?this.field.defaultvalue.indexOf("sql("):-1;
      if(pos_sql_keyword>-1){
        //prendi il contenuto sql
        const sql=this.field.defaultvalue.replace("sql(","").slice(0,-1);

        //avvia il sql
        this.field.params=[];
        this.systemService.executeSQL(sql).subscribe((result)=>{
          for(let r of result){
            const keys=Object.keys(r);
            this.field.params.push(r[keys[0]]);
          }
        })

      }

      let pos_localdb_keyword=this.field.defaultvalue?this.field.defaultvalue.indexOf("localdatabase()"):-1;
      if(pos_localdb_keyword>-1){
        this.is_select_localdb=true;
      }
      
      
      if(!Array.isArray(this.field.params)){
        try{
          if(this.field.params!=null)
            this.field.params=JSON.parse(this.field.params);
          else
            this.field.params=[];
        }catch{
          //prova a effettuare uno splitting della stringa
          this.field.params=this.field.params.split(";");
          
        }

      }
       
    }
    /*
    if(this.field.type=="address"){
      if(this.field.value==null){
        this.field.value={
          "name":"",
          "id":0
        }
      }
      
    }
    */
    if(this.field.type=="document" || this.field.type=="address"){
      
      if(this.field.value==null){
        this.field.value={
          "name":"",
          "id":0
        }
      }else{
        if(typeof(this.field.value)!="object"){
          try{
            this.field.value=JSON.parse(this.field.value)
          }catch{
            this.field.value={};
          }
        }
      }
    }

    if(this.field.type=="table"){
      if(!Array.isArray(this.field.params)){
        try{
          this.field.params=JSON.parse(this.field.params)
        }catch{
          this.field.params=[];
        }
        
      }

      if(this.field.value==null){
        this.field.value=[];
      }else{

      
        if(!Array.isArray(this.field.value)){
          try{
           
            this.field.value=JSON.parse(this.field.value)
          }catch{
            this.field.value=[];
          }
        }
      }

     


    }

    // if(this.field.type=="date"){
    //   this.DateDefaultValue(this.field)
    // }
  }

  ngOnChanges(){
   this.setDefaultValue()
  }

  DateDefaultValue(field){

    let dv=field.defaultvalue;
    for(let i=0;i<this.fields.length;i++){
      let f=this.fields[i];

        dv=dv.replaceAll("{{"+f.name+"}}",f.value);
        dv=dv.replaceAll("{{"+f.id+"}}",f.value);

      
    }

    // Nel caso siano stati passati i valori di fase
    if(this.phases.length>0){
      for(let p of this.phases){
        if(p.status==1){
          for(let s of p.sections){
            for(let f of s.fields){

                dv=dv.replaceAll("{{"+f.name+"}}",f.value);
                dv=dv.replaceAll("{{"+f.id+"}}",f.value);

            }
          }
        }
      }
    }
    
    field.value=new Date(eval(dv)).toMysqlDate();

    
  }

  getBasePath(path){
    if(path)
      return Globals.config.serverUrl+"/"+path;
    return "";
  }

  parseKeyword(value){
    if(this.record)
      return Helper.replaceKeyword(value,this.record);
    else
      return value;
  }

  downloadFile(relative_path){
    window.open( this.getBasePath(relative_path),"_blank");
  }

  /*
  uploadFile(){

    try{
      if(!Array.isArray(this.field.params)){
        this.field.params=JSON.parse(this.field.params);
      }
    }catch{
      this.field.params=[];
    }

    Globals.modal.showModal(UploadfileComponent,[
      {"name":"record","value":this.record},
      {"name":"params","value":this.field.params},

    ],(instance)=>{

      if(instance){
        this.field.value=instance['filename'];
      }
    },"md");
  }
    */

  pathImage(relative_path){
    if(relative_path==""){
      return "assets/placeholder_photo.jpg";
    }else{
      return this.getBasePath(relative_path);
    }
  }

  addFile(field){
    Globals.modal.showModal(UploadfileComponent,[
      {"name":"record","value":this.record},
      {"name":"params","value":field.params},
      {"name":"class","value":'p-3'}

    ],(instance)=>{
      if(instance && instance['filename']!=undefined){

        if(!Array.isArray(field.value))
          field.value=[];
        if(instance['filename'])
          field.value.push(instance['filename']);        
      }
    },"md");
  }

  unlinkAddress(record:any){
    record.value="";
  }


  addPhoto(field){
    Globals.modal.showModal(TakephotoComponent,[
      {"name":"mode","value":"modal"}
    ],(instance)=>{
      if(instance){
        this.uploadService.uploadImage64(instance.imageCaptured,"ads",(result)=>{
          if(!Array.isArray(field.value))
            field.value=[];
          
          field.value.push(result);
          
        },true);
      }
    });
  }
  takePhoto(field){
    Globals.modal.showModal(TakephotoComponent,[
      {"name":"mode","value":"modal"}
    ],(instance)=>{
      if(instance){
        this.uploadService.uploadImage64(instance.imageCaptured,"ads",(result)=>{
          field.value=result;
        },true);
      }
    });
  }


  isPhotoMultiple(field){
    if(!Array.isArray(field.params)){
      try{
        field.params=JSON.parse(field.params);
   
      }catch{
        field.params=[];
      }
    }


    if(field.params.length>0){
      for(let p of field.params){
        if(p.name=="multiple"){
          return p.value;
        }
      }
    }
    return false;
  }

  parseMultiplePhoto(value:any){
    if(!Array.isArray(value)){
      try{
        return JSON.parse(value);
  
      }catch{
        return [];
      }
    }

    return value;
  }

  deletePhoto(field,imgPath){
    Globals.modal.showConfirm("","Confermi di voler eliminare la foto?",()=>{  
      if(!Array.isArray(field.value)){
        field.value=JSON.parse(field.value);
      }

      for(let i=0;i<field.value.length;i++){
        if(field.value[i]==imgPath){
          field.value.splice(i,1);
          return;
        }
      }
    },"Sì. Elimina","No. Annulla","danger");

  }


  isFileMultiple(field){
    if(!Array.isArray(field.params)){
      try{
        field.params=JSON.parse(field.params);
   
      }catch{
        field.params=[];
      }
    }


    if(field.params && field.params.length>0){
      for(let p of field.params){
        if(p.name=="multiple"){
          return p.value;
        }
      }
    }
    return false;
  }

  parseMultipleFile(value:any){
    if(!Array.isArray(value)){
      try{
        return JSON.parse(value);
  
      }catch{
        return [];
      }
    }

    return value;
  }

  deleteFile(field,imgPath){
    Globals.modal.showConfirm("","Confermi di voler eliminare il file?",()=>{  
      if(!Array.isArray(field.value)){
        field.value=JSON.parse(field.value);
      }

      for(let i=0;i<field.value.length;i++){
        if(field.value[i]==imgPath){
          field.value.splice(i,1);
          return;
        }
      }
    },"Sì. Elimina","No. Annulla","danger");

  }


  calculateFormula(formula:string,field){

    var result;
    //verifica che non ci sia qualche funzione speciale
    if(formula.indexOf("$")>-1){
      
      //identifica la funzione speciale
      const start_pos_args=formula.indexOf("(");
      const end_pos_args=formula.indexOf(")");
      const str=formula.substring(formula.indexOf("$"),end_pos_args+1);
      const cmd=formula.substring(formula.indexOf("$")+1,start_pos_args);
      const args=formula.substring(start_pos_args+1,end_pos_args).split(";");
      result=0;
      switch(cmd){
        case "AVERAGETABLE": //effettua la media di un campi di una tabella
        case "SUMTABLE": //somma i campi di una tabella
          
          var countvalue=0;
          
          const table=this.fields.filter((x:any)=>x.name==args[0])[0];
          
          if(table){
            //verifica che il valore sia già scompattato
            if(!Array.isArray(table.value)){
              table.value=JSON.parse(table.value);
            }

            for(let s of table.value){
              
              for(let f of s.fields){
                if(f.name==args[1]){
                  if(f.value){
                    result=result+parseFloat(f.value);
                    countvalue++;
                  }
                }
              }
              
            }

            if(cmd=="AVERAGETABLE"){
              result=result/countvalue;
            }

          }

          



        break;
      }
      
      //sostituisci nella formula i valori degli altri campi
      for(let f of this.fields){
        formula=formula.replaceAll("{{"+f.name+"}}",f.value);
      }
      
      formula=formula.replace(str,result.toString())
     
      //field.value=result;

    }else{


      //sostituisci nella formula i valori degli altri campi
      for(let f of this.fields){
        formula=formula.replaceAll("{{"+f.name+"}}",f.value);
      }

    }
    
    result=eval(formula);
    field.value=result;

    return result;
    

  }

  /**
   * Avvia il trigger per il calcolo di tutte le formule presenti negli altri campi
   */
  triggerAllFormulas(){
    if(this.fields && this.fields.length>0){
      for(let f of this.fields){
        if(f.type=="formula"){
          this.calculateFormula(f.defaultvalue,f);
        }
      }
    }
  }
  
  // Gestisce l'incolla di un valore di valuta
  pasteCurrency(event: ClipboardEvent){
    const text=(event.clipboardData?.getData('text/plain') ?? '').trim();
    const italianFormat=/^-?(?:\d{1,3}(?:\.\d{3})+|\d+),\d+$/.test(text);
    const usFormat=/^-?\d{1,3}(?:,\d{3})+(?:\.\d+)?$/.test(text);
    if(!italianFormat && !usFormat){
      return;
    }
    Globals.message.showToaster("Conversione da formato valuta",ToastMode.INFO);
    event.preventDefault();
    const normalizedText=italianFormat
      ? text.replace(/\./g,'').replace(',','.')
      : text.replace(/,/g,'');
    this.field.value=Number(normalizedText).toFixed(2);
    this.triggerAllFormulas();
  }

  selectAddress(field){
    if(!Array.isArray(field.params)){
      try{
        field.params=JSON.parse(field.params);
      }catch{
        field.params=[];
      }
    }
    var id_type=0;
    if(Array.isArray(field.params)){
      for(let p of field.params){
        if(p.name=="id_type")
          id_type=parseInt(p.value);
      }
    }
      
    
    Globals.modal.showModal(AddressComponent,[
      {"name":"mode","value":"modal"},
      {"name":"title","value":"Seleziona un'anagrafica"},
      {"name":"id_type","value":id_type},
      
    ],(instance)=>{
      if(instance!=null){
        this.field.value={"name":instance['recordSelected'].name,"id":instance['recordSelected'].id};
      }
    })
  }

  openAddress(id){
    Globals.modal.showModal(AddressDetailsComponent,[
      {"name":"mode","value":"modal"},
      {"name":"id","value":id}
    ],(instance)=>{
      
    })
  }


  selectDocument(field){
    if(!Array.isArray(field.params)){
      try{
        field.params=JSON.parse(field.params);
      }catch{
        field.params=[];
      }
    }
    var id_type=0;
    if(Array.isArray(field.params)){
      for(let p of field.params){
        if(p.name=="id_type")
          id_type=parseInt(p.value);
      }
    }
      

    Globals.modal.showModal(DocumentsComponent,[
      {"name":"mode","value":"modal"},
      {"name":"titleModal","value":"Seleziona documento"},
      {"name":"id_type","value":id_type},
      
    ],(instance)=>{
      if(instance!=null){
        let record=instance['recordSelected'];
        let t=DocumentsModule.TypeID2TypeDocument(record.typedocument);
        this.field.value={"name":t.title+" "+record.reference+(record.referenceprefix?" "+record.referenceprefix:"")+" del "+record.date,"id":record.id};
      }
    })
  }


  printDocument(id:number){
    let documentsService:DocumentsService=new DocumentsService();
    let templatesService:TemplatesService=new TemplatesService();
    documentsService.getItem(id).subscribe((record:Documents)=>{
      if(record){

        templatesService.getTemplatesByModel("documents").subscribe((templates)=>{
          console.log("templates",templates);
          Globals.modal.showModal(TemplatePreviewComponent,[
            {"name":"mode","value":"modal"},
            {"name":"source","value":record},
            {"name":"templates","value":templates}
          ],()=>{},"lg");
        })
      }
    })
  } 

      

  openDocument(id){
    Globals.modal.showModal(DocumentsDetailsComponent,[
      {"name":"mode","value":"modal"},
      {"name":"id","value":id}
    ],(instance)=>{
      
    })
  }
  
  newDocument(id){
    let documentTemplateService:DocumentsTemplateService=new DocumentsTemplateService();
    documentTemplateService.createOpenDocument("dossier",this.record,0,"Contanti",[],(record:Documents)=>{
      
      let t=DocumentsModule.TypeID2TypeDocument(record.typedocument);
      this.field.value={"name":t.title+" "+record.reference+(record.referenceprefix?" "+record.referenceprefix:"")+" del "+record.date,"id":record.id};
   
    },false);
  }


  getFileTypeIcon(extension:String){
    switch(extension.toLowerCase()){
      case "png":
      case "jpg":
      case "bmp":
      case "tif":
      case "tiff":
      case "jpeg":
      case "gif":
        return "fa-image";
        
      case "kml":
      case "geojson":
      case "kmz":
        return "fa-map";
      case "doc":
        return "fa-file-word";
      case "ppt":
          return "fa-file-powerpoint";
      case "pdf":
          return "fa-file-pdf";
     case "xls":
      case "xlsx":
        return "fa-file-excel"
      default:
        return "fa-file"
    }
  }

  getExtension(path){
      if(path){
        const parts=path.split(".");
        if(parts.length>0)
          return parts[parts.length-1];
        else
          return "";
      }
      return "";
  }

  getFilename(path){

    if(path){
      const parts=path.split("/");
      if(parts.length>0)
        return parts[parts.length-1];
      else
        return "";
    }
    return "";
 
  }

  addRowTable(table,header){

    var row={fields:[],value:""};
    for(let h of header){
      var field={};
      Object.assign(field,h);
      row.fields.push(field);
    }
    
    if(table==null)
      table=[];
    table.push(row);

    if(table.length>0)
      this.openDetailTable(table[table.length-1],header);

  }

  deleteRowTable(table,row){
    for(let i=0;i<table.length;i++){
      if(table[i]==row){
        table.splice(i,1);
        return;
      }
    }
  }

  openImportModal(field:any){
    this.dataFromField=field;
    this.modalImportTableRef=this.modalService.open(this.modalImportTable,{size:"xl"});
  }

  importData(){
    if(this.dataFromFormat=="json"){
      this.importJSON(JSON.parse(this.dataFromImport),this.dataFromField);
    }
    if(this.dataFromFormat=="csv"){
      this.importCSV(this.tableDataImport,this.dataFromField);
    } 

    this.closeImportModal();
  }

  importJSON(values,dataFromField){
    //parserizza il testo
   

    //cicla ogni riga
    for(let row of values){
      if(!dataFromField.value)
        dataFromField.value=[];
      dataFromField.value.push({"fields":[]});
      for(let section of dataFromField.params){

        

        for(let field of section.fields){
          if(field.name in row){
            let value=row[field.name];
            if(field.type=="table"){
              let f={};
              Object.assign(f,field)
              Object.assign(value,this.importJSON(row[field.name],f).value);
            }

            dataFromField.value[dataFromField.value.length-1].fields.push(
                {
                  "name":field.name,
                  "value":value,
                  "type":field.type,
                  "show_label":field.type,
                  "params":field.params,
                  "required":field.required
                }
            );

           
            
            
          }
        }
      }
    }

    return dataFromField;

  }

  importCSV(values,dataFromField){
    let header=values[0];
    
    //cicla ogni riga
    for(let i=1;i<values.length;i++){
      let row=values[i];
      if(!dataFromField.value)
        dataFromField.value=[];
      dataFromField.value.push({"fields":[]});

      for(let section of dataFromField.params){
        for(let field of section.fields){
         
          let idx=header.indexOf(field.name);
          if(idx==-1)
            idx=header.indexOf(field.label);
         
          let value=row[idx];
         
          if(field.type=="table"){
            let f={};
            Object.assign(f,field)
            Object.assign(value,this.importJSON(row[field.name],f).value);
          }

          if(field.type=="date"){
            value=new Date(Date.parse(value)).toMysqlDate();
          }
          dataFromField.value[dataFromField.value.length-1].fields.push(
              {
                "name":field.name,
                "value":value,
                "type":field.type,
                "params":field.params,
                "required":field.required
              }
          );

           
            
            
          
        }
      }
    }
    return dataFromField;
  }

  closeImportModal(){
    this.modalImportTableRef.close("success");
  }

  checkFieldShow(field,headers){
  // Se show_list==1 non mostra il campo nella tabella ma solo nel dettaglio
    
    for(let h of headers){
      if(h.name==field.name){
        if("show_list" in h){
          
          return parseInt(h.show_list)==1?true:false;
        }
        
      }
    }

    return false;
  }


  openDetailTable(fields,header){
    for(let i=0;i<fields.fields.length;i++){

      for(let h=0;h<header.length;h++){
        if(fields.fields[i].name==header[h].name){
          fields.fields[i].show_list=header[h].show_list;
          fields.fields[i].searchable=header[h].searchable;
        }
      }
    }

    this.fields_detail=fields;
    this.modalTableDetailRef=this.modalService.open(this.modalTableDetail,{size:"md"});
  }

  closeDetailTable(){
    this.modalTableDetailRef.close("");
  }


  searchTable(data){

    // imposta tutti visibili
    for(let d of data){
      d.hide=false;
    }


    if(this.searchTableText!=""){
      for(let d of data){

        let count_hide=0;
        let count_boolean=0;

        for(let f of d.fields){
          if(f.type!="boolean"){
            if(f.value){
              
              // rintraccia il valore
              if(f.value.toString().indexOf(this.searchTableText)>-1){
                // imposta visibile
                d.hide=false;
              }else{
                count_hide++;
              }
            }else{
              count_hide++;
            }
          } else {
            count_boolean++;
          }
        }
        
        // nasconde se tutti i campi (tranne i booleani) non contengono il valore
        if(count_hide==d.fields.length-count_boolean){
          d.hide=true;
        }

      }
    }

    this.filterBoolean(data);

  }


  filterBoolean(data){
    
    const keys=Object.keys(this.filter_boolean);
   
    for(let d of data){


      for(let f of d.fields){

        for(let k of keys){
         if(f.type=="boolean" && f.name==k){
            
            if(parseInt(this.filter_boolean[k])>-1){
              if(parseInt(f.value)==parseInt(this.filter_boolean[k])){
                  
                }else{
                  d.hide=true;
                  
                }
              }
            }
          }
        }


        
      }
  }

  emptyTable(data){
    Globals.modal.showConfirm("","Confermi di voler eliminare tutti i valori della tabella?",()=>{        
      data.value=[];
    },"Sì, elimina","No. Annulla","danger");
  }

  parseCSV(text){
    if (!text) { return; }
    // suddividi in righe
    const rows = text.split(/\r?\n/).filter(r=>r.length>0);
    this.tableDataImport = rows.map(r => r.split('\t'));
  }


  onPaste(event: ClipboardEvent) {
    const text = (event.clipboardData?.getData('text/plain') ?? '').trim();
    this.parseCSV(text);
    /*
    if (!text) { return; }
    // suddividi in righe
    const rows = text.split(/\r?\n/).filter(r=>r.length>0);
    this.tableDataImport = rows.map(r => r.split('\t'));*/
  }


  addSelectValue(field){
    let message=prompt("Inserisci l'etichetta da aggiungere");
    if(message){
      field.params.push(message);
      let r:any={id:field.id,params:field.params}
      this.formsService.saveField(r,()=>{
        this.field.value=message;
      });
    }
  }


  isAgreed(field:any){
    
    if(field.access){
      
      
      if(field.access=="all"){
        return true;
      }

      if(field.access==""){
        return false;
      }

      try{
        if(typeof(field.access)=="string")
          field.access=JSON.parse(field.access);

        let group=field.access.filter((x:any)=>x.group==Globals.user.role);
        if(group.length>0){
          if(group[0].permission=="read" || group[0].permission=="all"){
            if(group[0].permission=="read") this.disabled=true;
            return true;
          }else{
            return false;
          }
        }

      }catch{
        return false;
      }

    }

    return true;
  }

}